import { defaultPrefixCls } from '../../config-provider';
export var TARGET_CLS = "".concat(defaultPrefixCls, "-wave-target");